import Hero from "../components/Hero";
// import BookCar from "../components/BookCar";
//  import Work from "../components/Work";
import PlanTrip from "../components/PlanTrip";
import PickCar from "../components/PickCar";
import Banner from "../components/Banner";
import ChooseUs from "../components/ChooseUs";
import Testimonials from "../components/Testimonials";
import Faq from "../components/Faq";
import Download from "../components/Download";
import Footer from "../components/Footer";
import PaymentMethodsSlider from "../components/PaymentMethodsSlider";
import SystemFeatures from "../components/SystemFeatures";
import FeaturesSection from "../components/FeaturesSection";

function Home() {
  return (
    <>
      <Hero />
      {/* <BookCar /> */}
      {/* <Work /> */}
      {/* <PlanTrip /> */}
      {/* <PickCar /> */}
      {/* <Banner /> */}
      {/* <PaymentMethodsSlider /> */}
      {/* <FeaturesSection /> */}
      <SystemFeatures />
      <ChooseUs />
      <Testimonials />
      <Faq />
      <Download />
      <Footer />
    </>
  );
}

export default Home;
